import styled from "styled-components";

export const UserDetailsWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export const InfoRowStyled = styled.div`
  display: flex;
  /* gap: 60px; */
  align-items: center;
`;
